import LabelBadg from "./LabelBadge";
import "./Label.css";
export default function LabelList({ labels = [] }) {
    return (
        < div className="workitem-label-container">
            {labels.map((l, i) => <LabelBadg key={i} label={l.Label} />)}
        </div>
    )
}